




// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { 
//   collection, 
//   query, 
//   where, 
//   orderBy, 
//   onSnapshot 
// } from 'firebase/firestore';
// import { getAuth, onAuthStateChanged } from 'firebase/auth';
// import { db } from '../../firebase/firebaseConfig';
// import './OrdersPage.css';

// const OrdersPage = () => {
//   const navigate = useNavigate();
//   const auth = getAuth();
//   const [orders, setOrders] = useState([]);
//   const [expandedOrders, setExpandedOrders] = useState(new Set());
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Helper function to get the latest status for a specific delivery speed
//   const getLatestStatusForDeliverySpeed = (order, deliverySpeed) => {
//     let status = order.status || 'Pending';

//     if (order.statusHistory && Array.isArray(order.statusHistory) && order.statusHistory.length > 0) {
//       const speedUpdates = order.statusHistory
//         .filter(update => update.deliverySpeed === deliverySpeed)
//         .sort((a, b) => {
//           const timeA = new Date(a.timestamp);
//           const timeB = new Date(b.timestamp);
//           return timeB - timeA;
//         });

//       if (speedUpdates.length > 0) {
//         status = speedUpdates[0].status;
//       }
//     }

//     return status;
//   };

//   // Get overall order status (most advanced status across all delivery speeds)
//   const getOverallOrderStatus = (order) => {
//     const statusPriority = {
//       'delivered': 5,
//       'out for delivery': 4,
//       'shipped': 3,
//       'processing': 2,
//       'pending': 1,
//       'cancelled': 0
//     };

//     let highestStatus = 'pending';
//     let highestPriority = 0;

//     // Check main status
//     const mainStatus = (order.status || 'pending').toLowerCase();
//     if (statusPriority[mainStatus] > highestPriority) {
//       highestStatus = mainStatus;
//       highestPriority = statusPriority[mainStatus];
//     }

//     // Check status history for all delivery speeds
//     if (order.statusHistory && Array.isArray(order.statusHistory)) {
//       order.statusHistory.forEach(update => {
//         const status = (update.status || 'pending').toLowerCase();
//         if (statusPriority[status] > highestPriority) {
//           highestStatus = status;
//           highestPriority = statusPriority[status];
//         }
//       });
//     }

//     return highestStatus;
//   };

//   useEffect(() => {
//     let unsubscribeAuth = null;
//     let unsubscribeOrders = null;

//     const setupOrdersListener = (userId) => {
//       try {
//         setLoading(true);
//         setError(null);

//         const ordersQuery = query(
//           collection(db, 'orders'),
//           where('userId', '==', userId),
//           orderBy('createdAt', 'desc')
//         );

//         unsubscribeOrders = onSnapshot(
//           ordersQuery,
//           (snapshot) => {
//             if (snapshot.empty) {
//               setOrders([]);
//               setLoading(false);
//               return;
//             }

//             const ordersData = snapshot.docs.map(doc => ({
//               id: doc.id,
//               ...doc.data()
//             }));

//             processOrdersData(ordersData);
//             setLoading(false);
//           },
//           (err) => {
//             console.error("Error setting up orders listener:", err);

//             if (err.code === 'failed-precondition') {
//               setupFallbackOrdersListener(userId);
//             } else {
//               setError("Failed to load your orders. Please try again later.");
//               setLoading(false);
//             }
//           }
//         );
//       } catch (error) {
//         console.error("Error in setupOrdersListener:", error);
//         setError("Failed to load your orders. Please try again later.");
//         setLoading(false);
//       }
//     };

//     const setupFallbackOrdersListener = (userId) => {
//       try {
//         console.log("Using fallback approach without orderBy");

//         const simpleQuery = query(
//           collection(db, 'orders'),
//           where('userId', '==', userId)
//         );

//         unsubscribeOrders = onSnapshot(
//           simpleQuery,
//           (snapshot) => {
//             if (snapshot.empty) {
//               setOrders([]);
//               setLoading(false);
//               return;
//             }

//             const ordersData = snapshot.docs.map(doc => ({
//               id: doc.id,
//               ...doc.data()
//             }));

//             const sortedOrders = ordersData.sort((a, b) => {
//               const dateA = a.createdAt || a.orderDate || 0;
//               const dateB = b.createdAt || b.orderDate || 0;

//               const timeA = dateA.toMillis ? dateA.toMillis() :
//                 (dateA.seconds ? dateA.seconds * 1000 : dateA);
//               const timeB = dateB.toMillis ? dateB.toMillis() :
//                 (dateB.seconds ? dateB.seconds * 1000 : timeB);

//               return timeB - timeA;
//             });

//             processOrdersData(sortedOrders);
//             setLoading(false);
//           },
//           (err) => {
//             console.error("Error setting up fallback orders listener:", err);
//             setError("Failed to load your orders. Please try again later.");
//             setLoading(false);
//           }
//         );
//       } catch (error) {
//         console.error("Error in setupFallbackOrdersListener:", error);
//         setError("Failed to load your orders. Please try again later.");
//         setLoading(false);
//       }
//     };

//     const processOrdersData = (ordersData) => {
//       const normalizedOrders = ordersData.map(order => {
//         if (order.items) {
//           return order;
//         } else if (order.productId) {
//           return {
//             ...order,
//             items: [{
//               id: order.productId,
//               name: order.productName,
//               price: order.price,
//               quantity: order.quantity || 1,
//               imageUrl: order.imageUrl,
//               image: order.imageUrl,
//               deliverySpeed: order.deliverySpeed || order.deliveryOption,
//               discountPercentage: order.discountPercentage || 0
//             }]
//           };
//         }
//         return order;
//       });

//       setOrders(normalizedOrders);
//     };

//     unsubscribeAuth = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         setupOrdersListener(user.uid);
//       } else {
//         setLoading(false);
//         navigate('/login');
//       }
//     });

//     return () => {
//       if (unsubscribeAuth) unsubscribeAuth();
//       if (unsubscribeOrders) unsubscribeOrders();
//     };
//   }, [navigate, auth]);

//   const toggleOrderExpansion = (orderId) => {
//     setExpandedOrders(prev => {
//       const newSet = new Set(prev);
//       if (newSet.has(orderId)) {
//         newSet.delete(orderId);
//       } else {
//         newSet.add(orderId);
//       }
//       return newSet;
//     });
//   };

//   const getOrdersByDeliverySpeed = (order) => {
//     const grouped = {
//       quick: [],
//       normal: [],
//       late: []
//     };

//     if (order.items && order.items.length > 0) {
//       const speedsInOrder = new Set();
//       order.items.forEach(item => {
//         const speed = item.deliverySpeed || 'normal';
//         speedsInOrder.add(speed);
//       });

//       speedsInOrder.forEach(speed => {
//         if (['quick', 'normal', 'late'].includes(speed)) {
//           const speedItems = order.items.filter(item =>
//             (item.deliverySpeed || 'normal') === speed
//           );

//           const speedStatus = getLatestStatusForDeliverySpeed(order, speed);
//           const subtotal = speedItems.reduce((total, item) =>
//             total + (item.price * (item.quantity || 1)), 0);

//           const orderEntry = {
//             ...order,
//             items: speedItems,
//             deliverySpeed: speed,
//             status: speedStatus,
//             subtotal: subtotal
//           };

//           grouped[speed].push(orderEntry);
//         }
//       });
//     }

//     return grouped;
//   };

//   const getStatusClass = (status) => {
//     if (!status) return 'status-pending';

//     switch (status.toLowerCase()) {
//       case 'pending':
//       case 'pending payment':
//         return 'status-pending';
//       case 'processing':
//         return 'status-processing';
//       case 'shipped':
//       case 'out for delivery':
//         return 'status-shipped';
//       case 'delivered':
//         return 'status-delivered';
//       case 'cancelled':
//         return 'status-cancelled';
//       default:
//         return 'status-pending';
//     }
//   };

//   const formatDate = (timestamp) => {
//     if (!timestamp) return 'N/A';

//     try {
//       let date;

//       if (timestamp.toDate) {
//         date = timestamp.toDate();
//       } else if (timestamp.seconds) {
//         date = new Date(timestamp.seconds * 1000);
//       } else {
//         date = new Date(timestamp);
//       }

//       return date.toLocaleDateString('en-IN', {
//         day: 'numeric',
//         month: 'short',
//         year: 'numeric'
//       }) + ' at ' + date.toLocaleTimeString('en-IN', {
//         hour: '2-digit',
//         minute: '2-digit'
//       });
//     } catch (error) {
//       console.error("Error formatting date:", error);
//       return 'Invalid Date';
//     }
//   };

//   const formatAmount = (amount) => {
//     if (typeof amount !== 'number') return '0.00';
//     return amount.toLocaleString('en-IN', { 
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2 
//     });
//   };
//  const handleGoBack = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     navigate(-1, { replace: true });
//   };

//   const getOrderTotal = (order) => {
//     if (order.items && order.items.length > 0) {
//       return order.items.reduce((total, item) => {
//         return total + (item.price * (item.quantity || 1));
//       }, 0);
//     }
//     return order.totalAmount || 0;
//   };

//   const getSpeedSubtotal = (order) => {
//     if (typeof order.subtotal === 'number') {
//       return formatAmount(order.subtotal);
//     }

//     if (order.items && order.items.length > 0) {
//       const subtotal = order.items.reduce((sum, item) => {
//         return sum + (item.price * (item.quantity || 1));
//       }, 0);
//       return formatAmount(subtotal);
//     }

//     return '0.00';
//   };

//   const getDeliverySpeedCounts = (order) => {
//     const counts = { quick: 0, normal: 0, late: 0 };

//     if (order.items && order.items.length > 0) {
//       order.items.forEach(item => {
//         const speed = item.deliverySpeed || 'normal';
//         if (counts.hasOwnProperty(speed)) {
//           counts[speed]++;
//         }
//       });
//     }

//     return counts;
//   };

//   if (loading) {
//     return (
//       <div className="orders-container">
//         <div className="loading-spinner"></div>
//         <p>Loading your orders...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="orders-container">
//         <div className="error-message">
//           <h2>Error loading orders</h2>
//           <p>{error}</p>
//           <button
//             className="action-button"
//             onClick={() => navigate('/profile')}
//           >
//             Back to Profile
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="orders-container">
//       <button className="go-back-btn2" onClick={handleGoBack}>
//        ← Go Back
//       </button>
//       <h1>My Orders</h1>

//       {orders.length === 0 ? (
//         <div className="no-orders">
//           <div className="no-orders-icon">
//             <svg width="64" height="64" viewBox="0 0 24 24" fill="currentColor">
//               <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 17H7c-.55 0-1-.45-1-1V5h2v3h8V5h2v14c0 .55-.45 1-1 1z" />
//             </svg>
//           </div>
//           <h2>No orders yet</h2>
//           <p>You haven't placed any orders yet. Start shopping to see your orders here!</p>
//           <button
//             className="shop-now-btn"
//             onClick={() => navigate('/products')}
//           >
//             Browse Products
//           </button>
//         </div>
//       ) : (
//         <div className="orders-list">
//           {orders.map((order) => {
//             const isExpanded = expandedOrders.has(order.id);
//             const overallStatus = getOverallOrderStatus(order);
//             const orderTotal = getOrderTotal(order);
//             const speedCounts = getDeliverySpeedCounts(order);
//             const groupedOrders = getOrdersByDeliverySpeed(order);

//             return (
//               <div key={order.id} className="order-card-wrapper">
//                 {/* Main Order Card */}
//                 <div className="order-card main-order-card">
//                   <div className="order-header">
//                     <div className="order-id">
//                       <span className="label">Order ID:</span>
//                       <span className="value">{order.orderId || order.displayOrderId || order.id.substring(0, 8).toUpperCase()}</span>
//                     </div>
//                     <div className={`order-status ${getStatusClass(overallStatus)}`}>
//                       {overallStatus || 'Pending'}
//                     </div>
//                   </div>

//                   <div className="order-summary">
//                     <div className="order-info">
//                       <div className="order-details">
//                         <div className="order-date">
//                           <span className="label">Ordered on:</span>
//                           <span className="value">{formatDate(order.createdAt || order.orderDate)}</span>
//                         </div>
//                         <div className="order-total">
//                           <span className="label">Total Amount:</span>
//                           <span className="value">₹{formatAmount(orderTotal)}</span>
//                         </div>
//                         <div className="items-count">
//                           <span className="label">Items:</span>
//                           <span className="value">{order.items?.length || 0}</span>
//                         </div>
//                       </div>

//                       <div className="delivery-speed-summary">
//                         <div className="speed-counts">
//                           {speedCounts.quick > 0 && (
//                             <div className="speed-count quick">
//                               <span className="speed-icon">⚡</span>
//                               <span>Quick: {speedCounts.quick}</span>
//                             </div>
//                           )}
//                           {speedCounts.normal > 0 && (
//                             <div className="speed-count normal">
//                               <span className="speed-icon">🚚</span>
//                               <span>Standard: {speedCounts.normal}</span>
//                             </div>
//                           )}
//                           {speedCounts.late > 0 && (
//                             <div className="speed-count late">
//                               <span className="speed-icon">🐌</span>
//                               <span>Eco: {speedCounts.late}</span>
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="order-actions">
//                     <button
//                       className="view-orders-btn"
//                       onClick={() => toggleOrderExpansion(order.id)}
//                     >
//                       {isExpanded ? 'Hide Orders' : 'View Orders'}
//                       <span className={`arrow ${isExpanded ? 'up' : 'down'}`}>
//                         {isExpanded ? '▲' : '▼'}
//                       </span>
//                     </button>
//                   </div>
//                 </div>

//                 {/* Expanded Order Details */}
//                 {isExpanded && (
//                   <div className="expanded-orders">
//                     {/* Quick Delivery Orders */}
//                     {groupedOrders.quick.length > 0 && (
//                       <div className="delivery-speed-section">
//                         <div className="delivery-speed-header quick-header">
//                           <span className="delivery-icon">⚡</span>
//                           Quick Delivery ({groupedOrders.quick.length} {groupedOrders.quick.length === 1 ? 'item' : 'items'})
//                         </div>
//                         <div className="speed-orders">
//                           {groupedOrders.quick.map((speedOrder, index) => (
//                             <div key={`quick-${index}`} className="speed-order-card">
//                               <div className="speed-order-header">
//                                 <div className={`speed-order-status ${getStatusClass(speedOrder.status)}`}>
//                                   {speedOrder.status || 'Pending'}
//                                 </div>
//                               </div>

//                               <div className="order-items">
//                                 {speedOrder.items.map((item, itemIndex) => (
//                                   <div key={itemIndex} className="order-item">
//                                     <div className="item-image">
//                                       {(item.imageUrl || item.image) ? (
//                                         <img 
//                                           src={item.imageUrl || item.image} 
//                                           alt={item.name}
//                                           onError={(e) => {
//                                             e.target.onerror = null;
//                                             e.target.src = "/images/product-placeholder.jpg";
//                                           }}
//                                         />
//                                       ) : (
//                                         <div className="no-image">No Image</div>
//                                       )}
//                                     </div>
//                                     <div className="item-details">
//                                       <h3 className="item-name">{item.name}</h3>
//                                       <div className="item-meta">
//                                         <span className="item-quantity">Qty: {item.quantity || 1}</span>
//                                         <span className="item-price">₹{item.price}</span>
//                                       </div>
//                                       {item.discountPercentage > 0 && (
//                                         <div className="item-discount">
//                                           {item.discountPercentage}% off
//                                         </div>
//                                       )}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>

//                               <div className="speed-order-total">
//                                 <span className="total-label">Subtotal:</span>
//                                 <span className="total-value">₹{getSpeedSubtotal(speedOrder)}</span>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     )}

//                     {/* Normal Delivery Orders */}
//                     {groupedOrders.normal.length > 0 && (
//                       <div className="delivery-speed-section">
//                         <div className="delivery-speed-header normal-header">
//                           <span className="delivery-icon">🚚</span>
//                           Standard Delivery ({groupedOrders.normal.length} {groupedOrders.normal.length === 1 ? 'item' : 'items'})
//                         </div>
//                         <div className="speed-orders">
//                           {groupedOrders.normal.map((speedOrder, index) => (
//                             <div key={`normal-${index}`} className="speed-order-card">
//                               <div className="speed-order-header">
//                                 <div className={`speed-order-status ${getStatusClass(speedOrder.status)}`}>
//                                   {speedOrder.status || 'Pending'}
//                                 </div>
//                               </div>

//                               <div className="order-items">
//                                 {speedOrder.items.map((item, itemIndex) => (
//                                   <div key={itemIndex} className="order-item">
//                                     <div className="item-image">
//                                       {(item.imageUrl || item.image) ? (
//                                         <img 
//                                           src={item.imageUrl || item.image} 
//                                           alt={item.name}
//                                           onError={(e) => {
//                                             e.target.onerror = null;
//                                             e.target.src = "/images/product-placeholder.jpg";
//                                           }}
//                                         />
//                                       ) : (
//                                         <div className="no-image">No Image</div>
//                                       )}
//                                     </div>
//                                     <div className="item-details">
//                                       <h3 className="item-name">{item.name}</h3>
//                                       <div className="item-meta">
//                                         <span className="item-quantity">Qty: {item.quantity || 1}</span>
//                                         <span className="item-price">₹{item.price}</span>
//                                       </div>
//                                       {item.discountPercentage > 0 && (
//                                         <div className="item-discount">
//                                           {item.discountPercentage}% off
//                                         </div>
//                                       )}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>

//                               <div className="speed-order-total">
//                                 <span className="total-label">Subtotal:</span>
//                                 <span className="total-value">₹{getSpeedSubtotal(speedOrder)}</span>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     )}

//                     {/* Late Delivery Orders */}
//                     {groupedOrders.late.length > 0 && (
//                       <div className="delivery-speed-section">
//                         <div className="delivery-speed-header late-header">
//                           <span className="delivery-icon">🐌</span>
//                           Eco Delivery ({groupedOrders.late.length} {groupedOrders.late.length === 1 ? 'item' : 'items'})
//                         </div>
//                         <div className="speed-orders">
//                           {groupedOrders.late.map((speedOrder, index) => (
//                             <div key={`late-${index}`} className="speed-order-card">
//                               <div className="speed-order-header">
//                                 <div className={`speed-order-status ${getStatusClass(speedOrder.status)}`}>
//                                   {speedOrder.status || 'Pending'}
//                                 </div>
//                               </div>

//                               <div className="order-items">
//                                 {speedOrder.items.map((item, itemIndex) => (
//                                   <div key={itemIndex} className="order-item">
//                                     <div className="item-image">
//                                       {(item.imageUrl || item.image) ? (
//                                         <img 
//                                           src={item.imageUrl || item.image} 
//                                           alt={item.name}
//                                           onError={(e) => {
//                                             e.target.onerror = null;
//                                             e.target.src = "/images/product-placeholder.jpg";
//                                           }}
//                                         />
//                                       ) : (
//                                         <div className="no-image">No Image</div>
//                                       )}
//                                     </div>
//                                     <div className="item-details">
//                                       <h3 className="item-name">{item.name}</h3>
//                                       <div className="item-meta">
//                                         <span className="item-quantity">Qty: {item.quantity || 1}</span>
//                                         <span className="item-price">₹{item.price}</span>
//                                       </div>
//                                       {item.discountPercentage > 0 && (
//                                         <div className="item-discount">
//                                           {item.discountPercentage}% off
//                                         </div>
//                                       )}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>

//                               <div className="speed-order-total">
//                                 <span className="total-label">Subtotal:</span>
//                                 <span className="total-value">₹{getSpeedSubtotal(speedOrder)}</span>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// };

// export default OrdersPage;


// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { 
//   collection, 
//   query, 
//   where, 
//   orderBy, 
//   onSnapshot,
//   addDoc,
//   updateDoc,
//   serverTimestamp,
//   doc,
//   getDoc
// } from 'firebase/firestore';
// import { getAuth, onAuthStateChanged } from 'firebase/auth';
// import { db } from '../../firebase/firebaseConfig';
// import './OrdersPage.css';

// const OrdersPage = () => {
//   const navigate = useNavigate();
//   const auth = getAuth();
//   const [orders, setOrders] = useState([]);
//   const [expandedOrders, setExpandedOrders] = useState(new Set());
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [userId, setUserId] = useState(null);
//   const [userName, setUserName] = useState('');

//   // Support feature states
//   const [activeSupportOrderId, setActiveSupportOrderId] = useState(null);
//   const [selectedIssue, setSelectedIssue] = useState('');
//   const [otherIssueText, setOtherIssueText] = useState('');
//   const [isSubmittingSupport, setIsSubmittingSupport] = useState(false);
//   const [supportSuccess, setSupportSuccess] = useState(false);
//   const [supportError, setSupportError] = useState('');
//   const [supportResponses, setSupportResponses] = useState({});

//   // Issue options
//   const issueOptions = [
//     { id: 'delayed', label: 'Order Delayed' },
//     { id: 'defective', label: 'Received Defective Item' },
//     { id: 'wrong-item', label: 'Received Wrong Item' },
//     { id: 'quality', label: 'Quality Issue' },
//     { id: 'damaged', label: 'Item Damaged During Shipping' },
//     { id: 'incomplete', label: 'Incomplete Order' },
//     { id: 'other', label: 'Other Issue' }
//   ];

//   // Helper function to get the latest status for a specific delivery speed
//   const getLatestStatusForDeliverySpeed = (order, deliverySpeed) => {
//     let status = order.status || 'Pending';

//     if (order.statusHistory && Array.isArray(order.statusHistory) && order.statusHistory.length > 0) {
//       const speedUpdates = order.statusHistory
//         .filter(update => update.deliverySpeed === deliverySpeed)
//         .sort((a, b) => {
//           const timeA = new Date(a.timestamp);
//           const timeB = new Date(b.timestamp);
//           return timeB - timeA;
//         });

//       if (speedUpdates.length > 0) {
//         status = speedUpdates[0].status;
//       }
//     }

//     return status;
//   };

//   // Get overall order status (most advanced status across all delivery speeds)
//   const getOverallOrderStatus = (order) => {
//     const statusPriority = {
//       'delivered': 5,
//       'out for delivery': 4,
//       'shipped': 3,
//       'processing': 2,
//       'pending': 1,
//       'cancelled': 0
//     };

//     let highestStatus = 'pending';
//     let highestPriority = 0;

//     // Check main status
//     const mainStatus = (order.status || 'pending').toLowerCase();
//     if (statusPriority[mainStatus] > highestPriority) {
//       highestStatus = mainStatus;
//       highestPriority = statusPriority[mainStatus];
//     }

//     // Check status history for all delivery speeds
//     if (order.statusHistory && Array.isArray(order.statusHistory)) {
//       order.statusHistory.forEach(update => {
//         const status = (update.status || 'pending').toLowerCase();
//         if (statusPriority[status] > highestPriority) {
//           highestStatus = status;
//           highestPriority = statusPriority[status];
//         }
//       });
//     }

//     return highestStatus;
//   };

//   useEffect(() => {
//     let unsubscribeAuth = null;
//     let unsubscribeOrders = null;

//     const setupOrdersListener = (userId) => {
//       try {
//         setLoading(true);
//         setError(null);

//         const ordersQuery = query(
//           collection(db, 'orders'),
//           where('userId', '==', userId),
//           orderBy('createdAt', 'desc')
//         );

//         unsubscribeOrders = onSnapshot(
//           ordersQuery,
//           (snapshot) => {
//             if (snapshot.empty) {
//               setOrders([]);
//               setLoading(false);
//               return;
//             }

//             const ordersData = snapshot.docs.map(doc => ({
//               id: doc.id,
//               ...doc.data()
//             }));

//             processOrdersData(ordersData);
//             setLoading(false);
//           },
//           (err) => {
//             console.error("Error setting up orders listener:", err);

//             if (err.code === 'failed-precondition') {
//               setupFallbackOrdersListener(userId);
//             } else {
//               setError("Failed to load your orders. Please try again later.");
//               setLoading(false);
//             }
//           }
//         );
//       } catch (error) {
//         console.error("Error in setupOrdersListener:", error);
//         setError("Failed to load your orders. Please try again later.");
//         setLoading(false);
//       }
//     };

//     const setupFallbackOrdersListener = (userId) => {
//       try {
//         console.log("Using fallback approach without orderBy");

//         const simpleQuery = query(
//           collection(db, 'orders'),
//           where('userId', '==', userId)
//         );

//         unsubscribeOrders = onSnapshot(
//           simpleQuery,
//           (snapshot) => {
//             if (snapshot.empty) {
//               setOrders([]);
//               setLoading(false);
//               return;
//             }

//             const ordersData = snapshot.docs.map(doc => ({
//               id: doc.id,
//               ...doc.data()
//             }));

//             const sortedOrders = ordersData.sort((a, b) => {
//               const dateA = a.createdAt || a.orderDate || 0;
//               const dateB = b.createdAt || b.orderDate || 0;

//               const timeA = dateA.toMillis ? dateA.toMillis() :
//                 (dateA.seconds ? dateA.seconds * 1000 : dateA);
//               const timeB = dateB.toMillis ? dateB.toMillis() :
//                 (dateB.seconds ? dateB.seconds * 1000 : timeB);

//               return timeB - timeA;
//             });

//             processOrdersData(sortedOrders);
//             setLoading(false);
//           },
//           (err) => {
//             console.error("Error setting up fallback orders listener:", err);
//             setError("Failed to load your orders. Please try again later.");
//             setLoading(false);
//           }
//         );
//       } catch (error) {
//         console.error("Error in setupFallbackOrdersListener:", error);
//         setError("Failed to load your orders. Please try again later.");
//         setLoading(false);
//       }
//     };

//     const processOrdersData = (ordersData) => {
//       const normalizedOrders = ordersData.map(order => {
//         if (order.items) {
//           return order;
//         } else if (order.productId) {
//           return {
//             ...order,
//             items: [{
//               id: order.productId,
//               name: order.productName,
//               price: order.price,
//               quantity: order.quantity || 1,
//               imageUrl: order.imageUrl,
//               image: order.imageUrl,
//               deliverySpeed: order.deliverySpeed || order.deliveryOption,
//               discountPercentage: order.discountPercentage || 0
//             }]
//           };
//         }
//         return order;
//       });

//       setOrders(normalizedOrders);
//     };

//     unsubscribeAuth = onAuthStateChanged(auth, (user) => {
//       if (user) {
//         setUserId(user.uid);
//         setUserName(user.displayName || '');
//         setupOrdersListener(user.uid);

//         // Get user's name from Firestore if available
//         const getUserDetails = async () => {
//           try {
//             const userDoc = await getDoc(doc(db, 'users', user.uid));
//             if (userDoc.exists()) {
//               const userData = userDoc.data();
//               setUserName(userData.name || user.displayName || '');
//             }
//           } catch (error) {
//             console.error("Error fetching user details:", error);
//           }
//         };

//         getUserDetails();
//       } else {
//         setLoading(false);
//         navigate('/login');
//       }
//     });

//     return () => {
//       if (unsubscribeAuth) unsubscribeAuth();
//       if (unsubscribeOrders) unsubscribeOrders();
//     };
//   }, [navigate, auth]);

//   // Fetch support requests for the current user
//   useEffect(() => {
//     if (!userId) return;

//     const supportQuery = query(
//       collection(db, 'support'),
//       where('userId', '==', userId)
//     );

//     const unsubscribe = onSnapshot(
//       supportQuery,
//       (snapshot) => {
//         if (snapshot.empty) {
//           setSupportResponses({});
//           return;
//         }

//         const supportData = {};
//         snapshot.docs.forEach(doc => {
//           const data = doc.data();
//           if (data.orderId) {
//             supportData[data.orderId] = {
//               id: doc.id,
//               ...data
//             };
//           }
//         });

//         setSupportResponses(supportData);
//       },
//       (err) => {
//         console.error("Error fetching support requests:", err);
//       }
//     );

//     return () => unsubscribe();
//   }, [userId]);

//   const toggleOrderExpansion = (orderId) => {
//     setExpandedOrders(prev => {
//       const newSet = new Set(prev);
//       if (newSet.has(orderId)) {
//         newSet.delete(orderId);
//       } else {
//         newSet.add(orderId);
//       }
//       return newSet;
//     });
//   };

//   const getOrdersByDeliverySpeed = (order) => {
//     const grouped = {
//       quick: [],
//       normal: [],
//       late: []
//     };

//     if (order.items && order.items.length > 0) {
//       const speedsInOrder = new Set();
//       order.items.forEach(item => {
//         const speed = item.deliverySpeed || 'normal';
//         speedsInOrder.add(speed);
//       });

//       speedsInOrder.forEach(speed => {
//         if (['quick', 'normal', 'late'].includes(speed)) {
//           const speedItems = order.items.filter(item =>
//             (item.deliverySpeed || 'normal') === speed
//           );

//           const speedStatus = getLatestStatusForDeliverySpeed(order, speed);
//           const subtotal = speedItems.reduce((total, item) =>
//             total + (item.price * (item.quantity || 1)), 0);

//           const orderEntry = {
//             ...order,
//             items: speedItems,
//             deliverySpeed: speed,
//             status: speedStatus,
//             subtotal: subtotal
//           };

//           grouped[speed].push(orderEntry);
//         }
//       });
//     }

//     return grouped;
//   };

//   const getStatusClass = (status) => {
//     if (!status) return 'status-pending';

//     switch (status.toLowerCase()) {
//       case 'pending':
//       case 'pending payment':
//         return 'status-pending';
//       case 'processing':
//         return 'status-processing';
//       case 'shipped':
//       case 'out for delivery':
//         return 'status-shipped';
//       case 'delivered':
//         return 'status-delivered';
//       case 'cancelled':
//         return 'status-cancelled';
//       default:
//         return 'status-pending';
//     }
//   };

//   // Check if order has a support request
//   const hasSupportRequest = (orderId) => {
//     return supportResponses[orderId] !== undefined;
//   };

//   // Get support request status for an order
//   const getSupportStatus = (orderId) => {
//     if (!hasSupportRequest(orderId)) return null;
//     return supportResponses[orderId].status || 'pending';
//   };

//   // Get support status class
//   const getSupportStatusClass = (status) => {
//     if (!status) return '';

//     switch (status.toLowerCase()) {
//       case 'pending':
//         return 'support-status-pending';
//       case 'processing':
//         return 'support-status-processing';
//       case 'responded':
//         return 'support-status-responded';
//       case 'resolved':
//         return 'support-status-resolved';
//       case 'cancelled':
//         return 'support-status-cancelled';
//       default:
//         return 'support-status-pending';
//     }
//   };

//   const formatDate = (timestamp) => {
//     if (!timestamp) return 'N/A';

//     try {
//       let date;

//       if (timestamp.toDate) {
//         date = timestamp.toDate();
//       } else if (timestamp.seconds) {
//         date = new Date(timestamp.seconds * 1000);
//       } else {
//         date = new Date(timestamp);
//       }

//       return date.toLocaleDateString('en-IN', {
//         day: 'numeric',
//         month: 'short',
//         year: 'numeric'
//       }) + ' at ' + date.toLocaleTimeString('en-IN', {
//         hour: '2-digit',
//         minute: '2-digit'
//       });
//     } catch (error) {
//       console.error("Error formatting date:", error);
//       return 'Invalid Date';
//     }
//   };

//   const formatAmount = (amount) => {
//     if (typeof amount !== 'number') return '0.00';
//     return amount.toLocaleString('en-IN', { 
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2 
//     });
//   };

//   const handleGoBack = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     navigate(-1, { replace: true });
//   };

//   const getOrderTotal = (order) => {
//     if (order.items && order.items.length > 0) {
//       return order.items.reduce((total, item) => {
//         return total + (item.price * (item.quantity || 1));
//       }, 0);
//     }
//     return order.totalAmount || 0;
//   };

//   const getSpeedSubtotal = (order) => {
//     if (typeof order.subtotal === 'number') {
//       return formatAmount(order.subtotal);
//     }

//     if (order.items && order.items.length > 0) {
//       const subtotal = order.items.reduce((sum, item) => {
//         return sum + (item.price * (item.quantity || 1));
//       }, 0);
//       return formatAmount(subtotal);
//     }

//     return '0.00';
//   };

//   const getDeliverySpeedCounts = (order) => {
//     const counts = { quick: 0, normal: 0, late: 0 };

//     if (order.items && order.items.length > 0) {
//       order.items.forEach(item => {
//         const speed = item.deliverySpeed || 'normal';
//         if (counts.hasOwnProperty(speed)) {
//           counts[speed]++;
//         }
//       });
//     }

//     return counts;
//   };

//   // Handle support button click
//   const handleSupportClick = (orderId) => {
//     // Check if there's an existing support request
//     if (hasSupportRequest(orderId)) {
//       // Prepopulate with existing data
//       const supportRequest = supportResponses[orderId];
//       setSelectedIssue(supportRequest.issueType || '');
//       setOtherIssueText(''); // Always start with empty text for additional info
//       setActiveSupportOrderId(orderId);
//     } else {
//       // Reset form state for new request
//       setSelectedIssue('');
//       setOtherIssueText('');
//       setSupportSuccess(false);
//       setSupportError('');
//       setActiveSupportOrderId(orderId);
//     }
//   };

//   // Close support modal
//   const closeSupportModal = () => {
//     setActiveSupportOrderId(null);
//     setSelectedIssue('');
//     setOtherIssueText('');
//     setSupportSuccess(false);
//     setSupportError('');
//   };

//   // Handle issue selection
//   const handleIssueSelect = (issueId) => {
//     setSelectedIssue(issueId);
//     // Clear other issue text if selected issue is not "other"
//     if (issueId !== 'other') {
//       setOtherIssueText('');
//     }
//   };

//   // Handle other issue text change
//   const handleOtherIssueChange = (e) => {
//     setOtherIssueText(e.target.value);
//   };

//   // Submit support request
//   const submitSupportRequest = async () => {
//     // Validate form
//     if (!hasSupportRequest(activeSupportOrderId) && !selectedIssue) {
//       setSupportError('Please select an issue');
//       return;
//     }

//     if (!hasSupportRequest(activeSupportOrderId) && selectedIssue === 'other' && !otherIssueText.trim()) {
//       setSupportError('Please describe your issue');
//       return;
//     }

//     if (hasSupportRequest(activeSupportOrderId) && !otherIssueText.trim()) {
//       setSupportError('Please provide additional information');
//       return;
//     }

//     setIsSubmittingSupport(true);
//     setSupportError('');

//     try {
//       // Get the active order
//       const activeOrder = orders.find(order => order.id === activeSupportOrderId);

//       if (!activeOrder) {
//         throw new Error('Order not found');
//       }

//       // Check if there's an existing support request
//       if (hasSupportRequest(activeSupportOrderId)) {
//         const supportRequest = supportResponses[activeSupportOrderId];
//         const supportDocRef = doc(db, 'support', supportRequest.id);

//         // Get current responses
//         const currentResponses = supportRequest.responses || [];

//         // Add user response with current timestamp instead of serverTimestamp
//         const now = new Date();
//         const newResponse = {
//           message: otherIssueText,
//           timestamp: now,
//           isAdmin: false
//         };

//         await updateDoc(supportDocRef, {
//           responses: [...currentResponses, newResponse],
//           updatedAt: serverTimestamp(),
//           // Reset status to pending if it was resolved
//           ...(supportRequest.status === 'resolved' ? { status: 'pending', resolvedAt: null } : {})
//         });
//       } else {
//         // Create support request document
//         const supportData = {
//           orderId: activeOrder.id,
//           orderDisplayId: activeOrder.orderId || activeOrder.displayOrderId || activeOrder.id,
//           userId: userId,
//           customerName: userName || activeOrder.customerName || 'Unknown',
//           issueType: selectedIssue,
//           issueDescription: selectedIssue === 'other' 
//             ? otherIssueText 
//             : issueOptions.find(option => option.id === selectedIssue)?.label || selectedIssue,
//           customDescription: selectedIssue === 'other' ? otherIssueText : '',
//           status: 'pending',
//           orderDate: activeOrder.orderDate || activeOrder.createdAt,
//           createdAt: serverTimestamp(),
//           updatedAt: serverTimestamp(),
//           orderItems: activeOrder.items || [],
//           orderAmount: activeOrder.totalAmount || getOrderTotal(activeOrder),
//           resolvedAt: null,
//           resolution: null,
//           responses: [] // Initialize empty responses array
//         };

//         // Add document to support collection
//         await addDoc(collection(db, 'support'), supportData);
//       }

//       // Show success message
//       setSupportSuccess(true);
//       setIsSubmittingSupport(false);

//       // Close the support modal after 3 seconds
//       setTimeout(() => {
//         closeSupportModal();
//       }, 3000);
//     } catch (error) {
//       console.error("Error submitting support request:", error);
//       setSupportError('Failed to submit support request. Please try again.');
//       setIsSubmittingSupport(false);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="orders-container">
//         <div className="loading-spinner"></div>
//         <p>Loading your orders...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="orders-container">
//         <div className="error-message">
//           <h2>Error loading orders</h2>
//           <p>{error}</p>
//           <button
//             className="action-button"
//             onClick={() => navigate('/profile')}
//           >
//             Back to Profile
//           </button>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="orders-container">

//       <h1>My Orders</h1>

//       {orders.length === 0 ? (
//         <div className="no-orders">
//           <div className="no-orders-icon">
//             <svg width="64" height="64" viewBox="0 0 24 24" fill="currentColor">
//               <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 17H7c-.55 0-1-.45-1-1V5h2v3h8V5h2v14c0 .55-.45 1-1 1z" />
//             </svg>
//           </div>
//           <h2>No orders yet</h2>
//           <p>You haven't placed any orders yet. Start shopping to see your orders here!</p>
//           <button
//             className="shop-now-btn"
//             onClick={() => navigate('/products')}
//           >
//             Browse Products
//           </button>
//         </div>
//       ) : (
//         <div className="orders-list">
//           {orders.map((order) => {
//             const isExpanded = expandedOrders.has(order.id);
//             const overallStatus = getOverallOrderStatus(order);
//             const orderTotal = getOrderTotal(order);
//             const speedCounts = getDeliverySpeedCounts(order);
//             const groupedOrders = getOrdersByDeliverySpeed(order);

//             return (
//               <div key={order.id} className="order-card-wrapper">
//                 {/* Main Order Card */}
//                 <div className="order-card main-order-card">
//                   <div className="order-header">
//                     <div className="order-id">
//                       <span className="label">Order ID:</span>
//                       <span className="value">{order.orderId || order.displayOrderId || order.id.substring(0, 8).toUpperCase()}</span>
//                     </div>
//                     <div className={`order-status ${getStatusClass(overallStatus)}`}>
//                       {overallStatus || 'Pending'}
//                     </div>
//                   </div>

//                   <div className="order-summary">
//                     <div className="order-info">
//                       <div className="order-details">
//                         <div className="order-date">
//                           <span className="label">Ordered on:</span>
//                           <span className="value">{formatDate(order.createdAt || order.orderDate)}</span>
//                         </div>
//                         <div className="order-total">
//                           <span className="label">Total Amount:</span>
//                           <span className="value">₹{formatAmount(orderTotal)}</span>
//                         </div>
//                         <div className="items-count">
//                           <span className="label">Items:</span>
//                           <span className="value">{order.items?.length || 0}</span>
//                         </div>
//                       </div>

//                       <div className="delivery-speed-summary">
//                         <div className="speed-counts">
//                           {speedCounts.quick > 0 && (
//                             <div className="speed-count quick">
//                               <span className="speed-icon">⚡</span>
//                               <span>Quick: {speedCounts.quick}</span>
//                             </div>
//                           )}
//                           {speedCounts.normal > 0 && (
//                             <div className="speed-count normal">
//                               <span className="speed-icon">🚚</span>
//                               <span>Standard: {speedCounts.normal}</span>
//                             </div>
//                           )}
//                           {speedCounts.late > 0 && (
//                             <div className="speed-count late">
//                               <span className="speed-icon">🐌</span>
//                               <span>Eco: {speedCounts.late}</span>
//                             </div>
//                           )}
//                         </div>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="order-actions">
//                     <button
//                       className="view-orders-btn"
//                       onClick={() => toggleOrderExpansion(order.id)}
//                     >
//                       {isExpanded ? 'Hide Orders' : 'View Orders'}
//                       <span className={`arrow ${isExpanded ? 'up' : 'down'}`}>
//                         {isExpanded ? '▲' : '▼'}
//                       </span>
//                     </button>

//                     {/* Support Button */}
//                     <button
//                       className={`support-btn ${hasSupportRequest(order.id) ? 'has-support' : ''}`}
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         handleSupportClick(order.id);
//                       }}
//                     >
//                       <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="support-icon">
//                         <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
//                       </svg>
//                       {hasSupportRequest(order.id) ? 'View Support' : 'Support'}
//                     </button>
//                   </div>
//                 </div>

//                 {/* Expanded Order Details */}
//                 {isExpanded && (
//                   <div className="expanded-orders">
//                     {/* Quick Delivery Orders */}
//                     {groupedOrders.quick.length > 0 && (
//                       <div className="delivery-speed-section">
//                         <div className="delivery-speed-header quick-header">
//                           <span className="delivery-icon">⚡</span>
//                           Quick Delivery ({groupedOrders.quick.length} {groupedOrders.quick.length === 1 ? 'item' : 'items'})
//                         </div>
//                         <div className="speed-orders">
//                           {groupedOrders.quick.map((speedOrder, index) => (
//                             <div key={`quick-${index}`} className="speed-order-card">
//                               <div className="speed-order-header">
//                                 <div className={`speed-order-status ${getStatusClass(speedOrder.status)}`}>
//                                   {speedOrder.status || 'Pending'}
//                                 </div>
//                               </div>

//                               <div className="order-items">
//                                 {speedOrder.items.map((item, itemIndex) => (
//                                   <div key={itemIndex} className="order-item">
//                                     <div className="item-image">
//                                       {(item.imageUrl || item.image) ? (
//                                         <img 
//                                           src={item.imageUrl || item.image} 
//                                           alt={item.name}
//                                           onError={(e) => {
//                                             e.target.onerror = null;
//                                             e.target.src = "/images/product-placeholder.jpg";
//                                           }}
//                                         />
//                                       ) : (
//                                         <div className="no-image">No Image</div>
//                                       )}
//                                     </div>
//                                     <div className="item-details">
//                                       <h3 className="item-name">{item.name}</h3>
//                                       <div className="item-meta">
//                                         <span className="item-quantity">Qty: {item.quantity || 1}</span>
//                                         <span className="item-price">₹{item.price}</span>
//                                       </div>
//                                       {item.discountPercentage > 0 && (
//                                         <div className="item-discount">
//                                           {item.discountPercentage}% off
//                                         </div>
//                                       )}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>

//                               <div className="speed-order-total">
//                                 <span className="total-label">Subtotal:</span>
//                                 <span className="total-value">₹{getSpeedSubtotal(speedOrder)}</span>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     )}

//                     {/* Normal Delivery Orders */}
//                     {groupedOrders.normal.length > 0 && (
//                       <div className="delivery-speed-section">
//                         <div className="delivery-speed-header normal-header">
//                           <span className="delivery-icon">🚚</span>
//                           Standard Delivery ({groupedOrders.normal.length} {groupedOrders.normal.length === 1 ? 'item' : 'items'})
//                         </div>
//                         <div className="speed-orders">
//                           {groupedOrders.normal.map((speedOrder, index) => (
//                             <div key={`normal-${index}`} className="speed-order-card">
//                               <div className="speed-order-header">
//                                 <div className={`speed-order-status ${getStatusClass(speedOrder.status)}`}>
//                                   {speedOrder.status || 'Pending'}
//                                 </div>
//                               </div>

//                               <div className="order-items">
//                                 {speedOrder.items.map((item, itemIndex) => (
//                                   <div key={itemIndex} className="order-item">
//                                     <div className="item-image">
//                                       {(item.imageUrl || item.image) ? (
//                                         <img 
//                                           src={item.imageUrl || item.image} 
//                                           alt={item.name}
//                                           onError={(e) => {
//                                             e.target.onerror = null;
//                                             e.target.src = "/images/product-placeholder.jpg";
//                                           }}
//                                         />
//                                       ) : (
//                                         <div className="no-image">No Image</div>
//                                       )}
//                                     </div>
//                                     <div className="item-details">
//                                       <h3 className="item-name">{item.name}</h3>
//                                       <div className="item-meta">
//                                         <span className="item-quantity">Qty: {item.quantity || 1}</span>
//                                         <span className="item-price">₹{item.price}</span>
//                                       </div>
//                                       {item.discountPercentage > 0 && (
//                                         <div className="item-discount">
//                                           {item.discountPercentage}% off
//                                         </div>
//                                       )}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>

//                               <div className="speed-order-total">
//                                 <span className="total-label">Subtotal:</span>
//                                 <span className="total-value">₹{getSpeedSubtotal(speedOrder)}</span>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     )}

//                     {/* Late Delivery Orders */}
//                     {groupedOrders.late.length > 0 && (
//                       <div className="delivery-speed-section">
//                         <div className="delivery-speed-header late-header">
//                           <span className="delivery-icon">🐌</span>
//                           Eco Delivery ({groupedOrders.late.length} {groupedOrders.late.length === 1 ? 'item' : 'items'})
//                         </div>
//                         <div className="speed-orders">
//                           {groupedOrders.late.map((speedOrder, index) => (
//                             <div key={`late-${index}`} className="speed-order-card">
//                               <div className="speed-order-header">
//                                 <div className={`speed-order-status ${getStatusClass(speedOrder.status)}`}>
//                                   {speedOrder.status || 'Pending'}
//                                 </div>
//                               </div>

//                               <div className="order-items">
//                                 {speedOrder.items.map((item, itemIndex) => (
//                                   <div key={itemIndex} className="order-item">
//                                     <div className="item-image">
//                                       {(item.imageUrl || item.image) ? (
//                                         <img 
//                                           src={item.imageUrl || item.image} 
//                                           alt={item.name}
//                                           onError={(e) => {
//                                             e.target.onerror = null;
//                                             e.target.src = "/images/product-placeholder.jpg";
//                                           }}
//                                         />
//                                       ) : (
//                                         <div className="no-image">No Image</div>
//                                       )}
//                                     </div>
//                                     <div className="item-details">
//                                       <h3 className="item-name">{item.name}</h3>
//                                       <div className="item-meta">
//                                         <span className="item-quantity">Qty: {item.quantity || 1}</span>
//                                         <span className="item-price">₹{item.price}</span>
//                                       </div>
//                                       {item.discountPercentage > 0 && (
//                                         <div className="item-discount">
//                                           {item.discountPercentage}% off
//                                         </div>
//                                       )}
//                                     </div>
//                                   </div>
//                                 ))}
//                               </div>

//                               <div className="speed-order-total">
//                                 <span className="total-label">Subtotal:</span>
//                                 <span className="total-value">₹{getSpeedSubtotal(speedOrder)}</span>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     )}

//                 {/* Support Status and Responses */}
//                     {hasSupportRequest(order.id) && (
//                       <div className="order-support-section">
//                         <div className="support-header">
//                           <span className="support-icon">
//                             <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
//                               <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
//                             </svg>
//                           </span>
//                           <span>Support Status: <strong className={getSupportStatusClass(getSupportStatus(order.id))}>
//                             {getSupportStatus(order.id)}
//                           </strong></span>
//                         </div>

//                         {supportResponses[order.id].responses && supportResponses[order.id].responses.length > 0 && (
//                           <div className="support-responses">
//                             {supportResponses[order.id].responses
//                               .filter(response => response.isAdmin)
//                               .map((response, index) => (
//                                 <div key={index} className="admin-response-item">
//                                   <div className="response-message">{response.message}</div>
//                                   <div className="response-time">{formatDate(response.timestamp)}</div>
//                                 </div>
//                               ))}
//                           </div>
//                         )}

//                         {getSupportStatus(order.id) !== 'resolved' && (
//                           <button
//                             className="add-info-btn"
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               handleSupportClick(order.id);
//                             }}
//                           >
//                             Add More Information
//                           </button>
//                         )}
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       )}

//       {/* Support Modal */}
//       {activeSupportOrderId && (
//         <div className="support-modal-overlay" onClick={closeSupportModal}>
//           <div className="support-modal" onClick={e => e.stopPropagation()}>
//             <div className="support-modal-header">
//               <h3>
//                 {hasSupportRequest(activeSupportOrderId) 
//                   ? 'Add Information to Support Request' 
//                   : 'Report an Issue'}
//               </h3>
//               <button className="close-modal-btn" onClick={closeSupportModal}>
//                 &times;
//               </button>
//             </div>

//             {supportSuccess ? (
//               <div className="support-success">
//                 <div className="success-icon">✓</div>
//                 <h4>
//                   {hasSupportRequest(activeSupportOrderId) 
//                     ? 'Information Added' 
//                     : 'Support Request Submitted'}
//                 </h4>
//                 <p>
//                   {hasSupportRequest(activeSupportOrderId)
//                     ? 'Your additional information has been added to the support request. Our team will review your update.'
//                     : 'Thank you for your feedback. Our team will review your issue and get back to you within 24-48 hours.'}
//                 </p>
//               </div>
//             ) : (
//               <div className="support-modal-content">
//                 <div className="support-modal-order-id">
//                   <strong>Order:</strong> {orders.find(o => o.id === activeSupportOrderId)?.orderId || 
//                     orders.find(o => o.id === activeSupportOrderId)?.displayOrderId || 
//                     activeSupportOrderId.substring(0, 8).toUpperCase()}
//                 </div>

//                 <div className="support-form">
//                   {!hasSupportRequest(activeSupportOrderId) ? (
//                     // New support request form
//                     <div className="form-group">
//                       <label>Select the issue you're experiencing:</label>

//                       <div className="issue-options">
//                         {issueOptions.map(option => (
//                           <div key={option.id} className="issue-option">
//                             <input
//                               type="radio"
//                               id={`issue-${option.id}`}
//                               name="issueType"
//                               value={option.id}
//                               checked={selectedIssue === option.id}
//                               onChange={() => handleIssueSelect(option.id)}
//                               className="issue-radio"
//                             />
//                             <label htmlFor={`issue-${option.id}`} className="issue-label">
//                               {option.label}
//                             </label>
//                           </div>
//                         ))}
//                       </div>

//                       {selectedIssue === 'other' && (
//                         <div className="form-group">
//                           <label htmlFor="otherIssueText">Please describe your issue:</label>
//                           <textarea
//                             id="otherIssueText"
//                             value={otherIssueText}
//                             onChange={handleOtherIssueChange}
//                             placeholder="Please provide details about your issue..."
//                             rows="4"
//                             className="other-issue-textarea"
//                           ></textarea>
//                         </div>
//                       )}
//                     </div>
//                   ) : (
//                     // Add information to existing request
//                     <div className="form-group">
//                       <label htmlFor="additionalInfo">Add more information:</label>
//                       <textarea
//                         id="additionalInfo"
//                         value={otherIssueText}
//                         onChange={handleOtherIssueChange}
//                         placeholder="Please provide any additional information or updates about your issue..."
//                         rows="4"
//                         className="other-issue-textarea"
//                       ></textarea>
//                     </div>
//                   )}

//                   {supportError && (
//                     <div className="error-message">
//                       {supportError}
//                     </div>
//                   )}

//                   <div className="support-actions">
//                     <button 
//                       className="cancel-btn"
//                       onClick={closeSupportModal}
//                       disabled={isSubmittingSupport}
//                     >
//                       Cancel
//                     </button>
//                     <button 
//                       className="submit-btn"
//                       onClick={submitSupportRequest}
//                       disabled={isSubmittingSupport}
//                     >
//                       {isSubmittingSupport ? (
//                         <>
//                           <span className="spinner"></span> 
//                           Submitting...
//                         </>
//                       ) : (
//                         hasSupportRequest(activeSupportOrderId) ? 'Send Message' : 'Submit'
//                       )}
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default OrdersPage;



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
  addDoc,
  updateDoc,
  serverTimestamp,
  doc,
  getDoc
} from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { db } from '../../firebase/firebaseConfig';
import './OrdersPage.css';

const OrdersPage = () => {
  const navigate = useNavigate();
  const auth = getAuth();
  const [orders, setOrders] = useState([]);
  const [expandedOrders, setExpandedOrders] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState('');

  // Support feature states
  const [activeSupportOrderId, setActiveSupportOrderId] = useState(null);
  const [selectedIssue, setSelectedIssue] = useState('');
  const [otherIssueText, setOtherIssueText] = useState('');
  const [isSubmittingSupport, setIsSubmittingSupport] = useState(false);
  const [supportSuccess, setSupportSuccess] = useState(false);
  const [supportError, setSupportError] = useState('');
  const [supportResponses, setSupportResponses] = useState({});

  // Issue options
  const issueOptions = [
    { id: 'delayed', label: 'Order Delayed' },
    { id: 'defective', label: 'Received Defective Item' },
    { id: 'wrong-item', label: 'Received Wrong Item' },
    { id: 'quality', label: 'Quality Issue' },
    { id: 'damaged', label: 'Item Damaged During Shipping' },
    { id: 'incomplete', label: 'Incomplete Order' },
    { id: 'other', label: 'Other Issue' }
  ];

  // Helper function to get the latest status for a specific delivery speed
  const getLatestStatusForDeliverySpeed = (order, deliverySpeed) => {
    let status = order.status || 'Pending';

    if (order.statusHistory && Array.isArray(order.statusHistory) && order.statusHistory.length > 0) {
      const speedUpdates = order.statusHistory
        .filter(update => update.deliverySpeed === deliverySpeed)
        .sort((a, b) => {
          const timeA = new Date(a.timestamp);
          const timeB = new Date(b.timestamp);
          return timeB - timeA;
        });

      if (speedUpdates.length > 0) {
        status = speedUpdates[0].status;
      }
    }

    return status;
  };

  // Get overall order status (most advanced status across all delivery speeds)
  const getOverallOrderStatus = (order) => {
    const statusPriority = {
      'delivered': 5,
      'out for delivery': 4,
      'shipped': 3,
      'processing': 2,
      'pending': 1,
      'cancelled': 0
    };

    let highestStatus = 'pending';
    let highestPriority = 0;

    // Check main status
    const mainStatus = (order.status || 'pending').toLowerCase();
    if (statusPriority[mainStatus] > highestPriority) {
      highestStatus = mainStatus;
      highestPriority = statusPriority[mainStatus];
    }

    // Check status history for all delivery speeds
    if (order.statusHistory && Array.isArray(order.statusHistory)) {
      order.statusHistory.forEach(update => {
        const status = (update.status || 'pending').toLowerCase();
        if (statusPriority[status] > highestPriority) {
          highestStatus = status;
          highestPriority = statusPriority[status];
        }
      });
    }

    return highestStatus;
  };

  useEffect(() => {
    let unsubscribeAuth = null;
    let unsubscribeOrders = null;

    const setupOrdersListener = (userId) => {
      try {
        setLoading(true);
        setError(null);

        const ordersQuery = query(
          collection(db, 'orders'),
          where('userId', '==', userId),
          orderBy('createdAt', 'desc')
        );

        unsubscribeOrders = onSnapshot(
          ordersQuery,
          (snapshot) => {
            if (snapshot.empty) {
              setOrders([]);
              setLoading(false);
              return;
            }

            const ordersData = snapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data()
            }));

            // Process and normalize orders data immediately
            processOrdersData(ordersData);
            setLoading(false);
          },
          (err) => {
            console.error("Error setting up orders listener:", err);

            if (err.code === 'failed-precondition') {
              setupFallbackOrdersListener(userId);
            } else {
              setError("Failed to load your orders. Please try again later.");
              setLoading(false);
            }
          }
        );
      } catch (error) {
        console.error("Error in setupOrdersListener:", error);
        setError("Failed to load your orders. Please try again later.");
        setLoading(false);
      }
    };

    const setupFallbackOrdersListener = (userId) => {
      try {
        console.log("Using fallback approach without orderBy");

        const simpleQuery = query(
          collection(db, 'orders'),
          where('userId', '==', userId)
        );

        unsubscribeOrders = onSnapshot(
          simpleQuery,
          (snapshot) => {
            if (snapshot.empty) {
              setOrders([]);
              setLoading(false);
              return;
            }

            const ordersData = snapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data()
            }));

            const sortedOrders = ordersData.sort((a, b) => {
              const dateA = a.createdAt || a.orderDate || 0;
              const dateB = b.createdAt || b.orderDate || 0;

              const timeA = dateA.toMillis ? dateA.toMillis() :
                (dateA.seconds ? dateA.seconds * 1000 : dateA);
              const timeB = dateB.toMillis ? dateB.toMillis() :
                (dateB.seconds ? dateB.seconds * 1000 : timeB);

              return timeB - timeA;
            });

            processOrdersData(sortedOrders);
            setLoading(false);
          },
          (err) => {
            console.error("Error setting up fallback orders listener:", err);
            setError("Failed to load your orders. Please try again later.");
            setLoading(false);
          }
        );
      } catch (error) {
        console.error("Error in setupFallbackOrdersListener:", error);
        setError("Failed to load your orders. Please try again later.");
        setLoading(false);
      }
    };

    const processOrdersData = (ordersData) => {
      const normalizedOrders = ordersData.map(order => {
        if (order.items) {
          return order;
        } else if (order.productId) {
          return {
            ...order,
            items: [{
              id: order.productId,
              name: order.productName,
              price: order.price,
              quantity: order.quantity || 1,
              imageUrl: order.imageUrl,
              image: order.imageUrl,
              deliverySpeed: order.deliverySpeed || order.deliveryOption,
              discountPercentage: order.discountPercentage || 0
            }]
          };
        }
        return order;
      });

      // Update orders state immediately to trigger re-render
      setOrders(normalizedOrders);
    };

    unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUserId(user.uid);
        setUserName(user.displayName || '');
        setupOrdersListener(user.uid);

        // Get user's name from Firestore if available
        const getUserDetails = async () => {
          try {
            const userDoc = await getDoc(doc(db, 'users', user.uid));
            if (userDoc.exists()) {
              const userData = userDoc.data();
              setUserName(userData.name || user.displayName || '');
            }
          } catch (error) {
            console.error("Error fetching user details:", error);
          }
        };

        getUserDetails();
      } else {
        setLoading(false);
        navigate('/login');
      }
    });

    return () => {
      if (unsubscribeAuth) unsubscribeAuth();
      if (unsubscribeOrders) unsubscribeOrders();
    };
  }, [navigate, auth]);

  // Fetch support requests for the current user
  useEffect(() => {
    if (!userId) return;

    const supportQuery = query(
      collection(db, 'support'),
      where('userId', '==', userId)
    );

    const unsubscribe = onSnapshot(
      supportQuery,
      (snapshot) => {
        if (snapshot.empty) {
          setSupportResponses({});
          return;
        }

        const supportData = {};
        snapshot.docs.forEach(doc => {
          const data = doc.data();
          if (data.orderId) {
            supportData[data.orderId] = {
              id: doc.id,
              ...data
            };
          }
        });

        setSupportResponses(supportData);
      },
      (err) => {
        console.error("Error fetching support requests:", err);
      }
    );

    return () => unsubscribe();
  }, [userId]);

  const toggleOrderExpansion = (orderId) => {
    setExpandedOrders(prev => {
      const newSet = new Set(prev);
      if (newSet.has(orderId)) {
        newSet.delete(orderId);
      } else {
        newSet.add(orderId);
      }
      return newSet;
    });
  };

  const getOrdersByDeliverySpeed = (order) => {
    // Simplified - all items use normal delivery, no grouping needed
    const grouped = {
      quick: [],
      normal: [],
      late: []
    };

    if (order.items && order.items.length > 0) {
      // All items go to normal delivery
      const subtotal = order.items.reduce((total, item) =>
        total + (item.price * (item.quantity || 1)), 0);

      const orderEntry = {
        ...order,
        items: order.items,
        deliverySpeed: 'normal',
        status: order.status,
        subtotal: subtotal
      };

      grouped.normal.push(orderEntry);
    }

    return grouped;
  };

  const getStatusClass = (status) => {
    if (!status) return 'status-pending';

    switch (status.toLowerCase()) {
      case 'pending':
      case 'pending payment':
        return 'status-pending';
      case 'processing':
        return 'status-processing';
      case 'shipped':
      case 'out for delivery':
        return 'status-shipped';
      case 'delivered':
        return 'status-delivered';
      case 'cancelled':
        return 'status-cancelled';
      default:
        return 'status-pending';
    }
  };

  // Check if order has a support request
  const hasSupportRequest = (orderId) => {
    return supportResponses[orderId] !== undefined;
  };

  // Get support request status for an order
  const getSupportStatus = (orderId) => {
    if (!hasSupportRequest(orderId)) return null;
    return supportResponses[orderId].status || 'pending';
  };

  // Get support status class
  const getSupportStatusClass = (status) => {
    if (!status) return '';

    switch (status.toLowerCase()) {
      case 'pending':
        return 'support-status-pending';
      case 'processing':
        return 'support-status-processing';
      case 'responded':
        return 'support-status-responded';
      case 'resolved':
        return 'support-status-resolved';
      case 'cancelled':
        return 'support-status-cancelled';
      default:
        return 'support-status-pending';
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A';

    try {
      let date;

      if (timestamp.toDate) {
        date = timestamp.toDate();
      } else if (timestamp.seconds) {
        date = new Date(timestamp.seconds * 1000);
      } else {
        date = new Date(timestamp);
      }

      return date.toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      }) + ' at ' + date.toLocaleTimeString('en-IN', {
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      console.error("Error formatting date:", error);
      return 'Invalid Date';
    }
  };

  const formatAmount = (amount) => {
    if (typeof amount !== 'number') return '0.00';
    return amount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  };

  const handleGoBack = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(-1, { replace: true });
  };

  // Updated function to get order total - prioritize totalAmount
  const getOrderTotal = (order) => {
    // First priority: use totalAmount if available
    if (order.totalAmount && typeof order.totalAmount === 'number') {
      return order.totalAmount;
    }

    // Second priority: calculate from items
    if (order.items && order.items.length > 0) {
      return order.items.reduce((total, item) => {
        return total + (item.price * (item.quantity || 1));
      }, 0);
    }

    // Fallback: use any available amount fields
    return order.price || 0;
  };

  // Updated function for speed subtotals - keep for individual item calculations
  const getSpeedSubtotal = (order) => {
    if (typeof order.subtotal === 'number') {
      return formatAmount(order.subtotal);
    }

    if (order.items && order.items.length > 0) {
      const subtotal = order.items.reduce((sum, item) => {
        return sum + (item.price * (item.quantity || 1));
      }, 0);
      return formatAmount(subtotal);
    }

    return '0.00';
  };

  const getDeliverySpeedCounts = (order) => {
    const counts = { quick: 0, normal: 0, late: 0 };

    if (order.items && order.items.length > 0) {
      order.items.forEach(item => {
        const speed = item.deliverySpeed || 'normal';
        if (counts.hasOwnProperty(speed)) {
          counts[speed]++;
        }
      });
    }

    return counts;
  };

  // Handle support button click
  const handleSupportClick = (orderId) => {
    // Check if there's an existing support request
    if (hasSupportRequest(orderId)) {
      // Prepopulate with existing data
      const supportRequest = supportResponses[orderId];
      setSelectedIssue(supportRequest.issueType || '');
      setOtherIssueText(''); // Always start with empty text for additional info
      setActiveSupportOrderId(orderId);
    } else {
      // Reset form state for new request
      setSelectedIssue('');
      setOtherIssueText('');
      setSupportSuccess(false);
      setSupportError('');
      setActiveSupportOrderId(orderId);
    }
  };

  // Close support modal
  const closeSupportModal = () => {
    setActiveSupportOrderId(null);
    setSelectedIssue('');
    setOtherIssueText('');
    setSupportSuccess(false);
    setSupportError('');
  };

  // Handle issue selection
  const handleIssueSelect = (issueId) => {
    setSelectedIssue(issueId);
    // Clear other issue text if selected issue is not "other"
    if (issueId !== 'other') {
      setOtherIssueText('');
    }
  };

  // Handle other issue text change
  const handleOtherIssueChange = (e) => {
    setOtherIssueText(e.target.value);
  };

  // Submit support request
  const submitSupportRequest = async () => {
    // Validate form
    if (!hasSupportRequest(activeSupportOrderId) && !selectedIssue) {
      setSupportError('Please select an issue');
      return;
    }

    if (!hasSupportRequest(activeSupportOrderId) && selectedIssue === 'other' && !otherIssueText.trim()) {
      setSupportError('Please describe your issue');
      return;
    }

    if (hasSupportRequest(activeSupportOrderId) && !otherIssueText.trim()) {
      setSupportError('Please provide additional information');
      return;
    }

    setIsSubmittingSupport(true);
    setSupportError('');

    try {
      // Get the active order
      const activeOrder = orders.find(order => order.id === activeSupportOrderId);

      if (!activeOrder) {
        throw new Error('Order not found');
      }

      // Check if there's an existing support request
      if (hasSupportRequest(activeSupportOrderId)) {
        const supportRequest = supportResponses[activeSupportOrderId];
        const supportDocRef = doc(db, 'support', supportRequest.id);

        // Get current responses
        const currentResponses = supportRequest.responses || [];

        // Add user response with current timestamp instead of serverTimestamp
        const now = new Date();
        const newResponse = {
          message: otherIssueText,
          timestamp: now,
          isAdmin: false
        };

        await updateDoc(supportDocRef, {
          responses: [...currentResponses, newResponse],
          updatedAt: serverTimestamp(),
          // Reset status to pending if it was resolved
          ...(supportRequest.status === 'resolved' ? { status: 'pending', resolvedAt: null } : {})
        });
      } else {
        // Create support request document
        const supportData = {
          orderId: activeOrder.id,
          orderDisplayId: activeOrder.orderId || activeOrder.displayOrderId || activeOrder.id,
          userId: userId,
          customerName: userName || activeOrder.customerName || 'Unknown',
          issueType: selectedIssue,
          issueDescription: selectedIssue === 'other'
            ? otherIssueText
            : issueOptions.find(option => option.id === selectedIssue)?.label || selectedIssue,
          customDescription: selectedIssue === 'other' ? otherIssueText : '',
          status: 'pending',
          orderDate: activeOrder.orderDate || activeOrder.createdAt,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp(),
          orderItems: activeOrder.items || [],
          orderAmount: getOrderTotal(activeOrder), // Now uses totalAmount properly
          resolvedAt: null,
          resolution: null,
          responses: [] // Initialize empty responses array
        };

        // Add document to support collection
        await addDoc(collection(db, 'support'), supportData);
      }

      // Show success message
      setSupportSuccess(true);
      setIsSubmittingSupport(false);

      // Close the support modal after 3 seconds
      setTimeout(() => {
        closeSupportModal();
      }, 3000);
    } catch (error) {
      console.error("Error submitting support request:", error);
      setSupportError('Failed to submit support request. Please try again.');
      setIsSubmittingSupport(false);
    }
  };

  if (loading) {
    return (
      <div className="orders-container">
        <div className="loading-spinner"></div>
        <p>Loading your orders...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="orders-container">
        <div className="error-message">
          <h2>Error loading orders</h2>
          <p>{error}</p>
          <button
            className="action-button"
            onClick={() => navigate('/profile')}
          >
            Back to Profile
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="orders-container">

      <button className="go-back-btn2" onClick={handleGoBack}>
          <span className="go-back-icon" aria-hidden="true">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </span>
          <span>Go Back</span>
      </button>


      <h1>My Orders</h1>

      {orders.length === 0 ? (
        <div className="no-orders">
          <div className="no-orders-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 17H7c-.55 0-1-.45-1-1V5h2v3h8V5h2v14c0 .55-.45 1-1 1z" />
            </svg>
          </div>
          <h2>No orders yet</h2>
          <p>You haven't placed any orders yet. Start shopping to see your orders here!</p>
          <button
            className="shop-now-btn"
            onClick={() => navigate('/products')}
          >
            Browse Products
          </button>
        </div>
      ) : (
        <div className="orders-list">
          {orders.map((order) => {
            const isExpanded = expandedOrders.has(order.id);
            const overallStatus = getOverallOrderStatus(order);
            const orderTotal = getOrderTotal(order); // Now properly uses totalAmount
            const speedCounts = getDeliverySpeedCounts(order);
            const groupedOrders = getOrdersByDeliverySpeed(order);

            return (
              <div key={order.id} className="order-card-wrapper">
                {/* Main Order Card */}
                <div className="order-card main-order-card">
                  <div className="order-header">
                    <div className="order-id">
                      <span className="label">Order ID:</span>
                      <span className="value">{order.orderId || order.displayOrderId || order.id.substring(0, 8).toUpperCase()}</span>
                    </div>
                    <div className={`order-status ${getStatusClass(overallStatus)}`}>
                      {overallStatus || 'Pending'}
                    </div>
                  </div>

                  <div className="order-summary">
                    <div className="order-info">
                      <div className="order-details">
                        <div className="order-date">
                          <span className="label">Ordered on:</span>
                          <span className="value">{formatDate(order.createdAt || order.orderDate)}</span>
                        </div>
                        <div className="order-total">
                          <span className="label">Total Amount:</span>
                          <span className="value">₹{formatAmount(orderTotal)}</span>
                        </div>
                        <div className="items-count">
                          <span className="label">Items:</span>
                          <span className="value">{order.items?.length || 1}</span>
                        </div>
                      </div>

                      <div className="delivery-speed-summary">
                        <div className="speed-counts">
                          {speedCounts.quick > 0 && (
                            <div className="speed-count quick">
                              <span className="speed-icon">⚡</span>
                              <span>Quick: {speedCounts.quick}</span>
                            </div>
                          )}
                          {speedCounts.normal > 0 && (
                            <div className="speed-count normal">
                              <span className="speed-icon">🚚</span>
                              <span>Standard: {speedCounts.normal}</span>
                            </div>
                          )}
                          {speedCounts.late > 0 && (
                            <div className="speed-count late">
                              <span className="speed-icon">🐌</span>
                              <span>Eco: {speedCounts.late}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="order-actions">
                    <button
                      className="view-orders-btn"
                      onClick={() => toggleOrderExpansion(order.id)}
                    >
                      {isExpanded ? 'Hide Orders' : 'View Orders'}
                      <span className={`arrow ${isExpanded ? 'up' : 'down'}`}>
                        {isExpanded ? '▲' : '▼'}
                      </span>
                    </button>

                    {/* Support Button */}
                    <button
                      className={`support-btn ${hasSupportRequest(order.id) ? 'has-support' : ''}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleSupportClick(order.id);
                      }}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="support-icon">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                      </svg>
                      {hasSupportRequest(order.id) ? 'View Support' : 'Support'}
                    </button>
                  </div>
                </div>

                {/* Expanded Order Details */}
                {isExpanded && (
                  <div className="expanded-orders">
                    {/* Standard Delivery Orders - All items */}
                    {groupedOrders.normal.length > 0 && (
                      <div className="delivery-speed-section">
                        <div className="delivery-speed-header normal-header">
                          <span className="delivery-icon">🚚</span>
                          Standard Delivery ({groupedOrders.normal.length} {groupedOrders.normal.length === 1 ? 'item' : 'items'})
                        </div>
                        <div className="speed-orders">
                          {groupedOrders.normal.map((speedOrder, index) => (
                            <div key={`normal-${index}`} className="speed-order-card">
                              <div className="speed-order-header">
                                <div className={`speed-order-status ${getStatusClass(speedOrder.status)}`}>
                                  {speedOrder.status || 'Pending'}
                                </div>
                              </div>

                              <div className="order-items">
                                {speedOrder.items.map((item, itemIndex) => (
                                  <div key={itemIndex} className="order-item">
                                    <div className="item-image">
                                      {(item.imageUrl || item.image) ? (
                                        <img
                                          src={item.imageUrl || item.image}
                                          alt={item.name}
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "/images/product-placeholder.jpg";
                                          }}
                                        />
                                      ) : (
                                        <div className="no-image">No Image</div>
                                      )}
                                    </div>
                                    <div className="item-details">
                                      <h3 className="item-name">{item.name}</h3>
                                      <div className="item-meta">
                                        <span className="item-quantity">Qty: {item.quantity || 1}</span>
                                        <span className="item-price">₹{item.price}</span>
                                      </div>
                                      {item.discountPercentage > 0 && (
                                        <div className="item-discount">
                                          {item.discountPercentage}% off
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>

                              <div className="speed-order-total">
                                <span className="total-label">Subtotal:</span>
                                <span className="total-value">₹{getSpeedSubtotal(speedOrder)}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Normal Delivery Orders */}
                    {groupedOrders.normal.length > 0 && (
                      <div className="delivery-speed-section">
                        <div className="delivery-speed-header normal-header">
                          <span className="delivery-icon">🚚</span>
                          Standard Delivery ({groupedOrders.normal.length} {groupedOrders.normal.length === 1 ? 'item' : 'items'})
                        </div>
                        <div className="speed-orders">
                          {groupedOrders.normal.map((speedOrder, index) => (
                            <div key={`normal-${index}`} className="speed-order-card">
                              <div className="speed-order-header">
                                <div className={`speed-order-status ${getStatusClass(speedOrder.status)}`}>
                                  {speedOrder.status || 'Pending'}
                                </div>
                              </div>

                              <div className="order-items">
                                {speedOrder.items.map((item, itemIndex) => (
                                  <div key={itemIndex} className="order-item">
                                    <div className="item-image">
                                      {(item.imageUrl || item.image) ? (
                                        <img
                                          src={item.imageUrl || item.image}
                                          alt={item.name}
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = "/images/product-placeholder.jpg";
                                          }}
                                        />
                                      ) : (
                                        <div className="no-image">No Image</div>
                                      )}
                                    </div>
                                    <div className="item-details">
                                      <h3 className="item-name">{item.name}</h3>
                                      <div className="item-meta">
                                        <span className="item-quantity">Qty: {item.quantity || 1}</span>
                                        <span className="item-price">₹{item.price}</span>
                                      </div>
                                      {item.discountPercentage > 0 && (
                                        <div className="item-discount">
                                          {item.discountPercentage}% off
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>

                              <div className="speed-order-total">
                                <span className="total-label">Subtotal:</span>
                                <span className="total-value">₹{getSpeedSubtotal(speedOrder)}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Support Status and Responses */}
                    {hasSupportRequest(order.id) && (
                      <div className="order-support-section">
                        <div className="support-header">
                          <span className="support-icon">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
                            </svg>
                          </span>
                          <span>Support Status: <strong className={getSupportStatusClass(getSupportStatus(order.id))}>
                            {getSupportStatus(order.id)}
                          </strong></span>
                        </div>

                        {supportResponses[order.id].responses && supportResponses[order.id].responses.length > 0 && (
                          <div className="support-responses">
                            {supportResponses[order.id].responses
                              .filter(response => response.isAdmin)
                              .map((response, index) => (
                                <div key={index} className="admin-response-item">
                                  <div className="response-message">{response.message}</div>
                                  <div className="response-time">{formatDate(response.timestamp)}</div>
                                </div>
                              ))}
                          </div>
                        )}

                        {getSupportStatus(order.id) !== 'resolved' && (
                          <button
                            className="add-info-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleSupportClick(order.id);
                            }}
                          >
                            Add More Information
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* Support Modal */}
      {activeSupportOrderId && (
        <div className="support-modal-overlay" onClick={closeSupportModal}>
          <div className="support-modal" onClick={e => e.stopPropagation()}>
            <div className="support-modal-header">
              <h3>
                {hasSupportRequest(activeSupportOrderId)
                  ? 'Add Information to Support Request'
                  : 'Report an Issue'}
              </h3>
              <button className="close-modal-btn" onClick={closeSupportModal}>
                &times;
              </button>
            </div>

            {supportSuccess ? (
              <div className="support-success">
                <div className="success-icon">✓</div>
                <h4>
                  {hasSupportRequest(activeSupportOrderId)
                    ? 'Information Added'
                    : 'Support Request Submitted'}
                </h4>
                <p>
                  {hasSupportRequest(activeSupportOrderId)
                    ? 'Your additional information has been added to the support request. Our team will review your update.'
                    : 'Thank you for your feedback. Our team will review your issue and get back to you within 24-48 hours.'}
                </p>
              </div>
            ) : (
              <div className="support-modal-content">
                <div className="support-modal-order-id">
                  <strong>Order:</strong> {orders.find(o => o.id === activeSupportOrderId)?.orderId ||
                    orders.find(o => o.id === activeSupportOrderId)?.displayOrderId ||
                    activeSupportOrderId.substring(0, 8).toUpperCase()}
                </div>

                <div className="support-form">
                  {!hasSupportRequest(activeSupportOrderId) ? (
                    // New support request form
                    <div className="form-group">
                      <label>Select the issue you're experiencing:</label>

                      <div className="issue-options">
                        {issueOptions.map(option => (
                          <div key={option.id} className="issue-option">
                            <input
                              type="radio"
                              id={`issue-${option.id}`}
                              name="issueType"
                              value={option.id}
                              checked={selectedIssue === option.id}
                              onChange={() => handleIssueSelect(option.id)}
                              className="issue-radio"
                            />
                            <label htmlFor={`issue-${option.id}`} className="issue-label">
                              {option.label}
                            </label>
                          </div>
                        ))}
                      </div>

                      {selectedIssue === 'other' && (
                        <div className="form-group">
                          <label htmlFor="otherIssueText">Please describe your issue:</label>
                          <textarea
                            id="otherIssueText"
                            value={otherIssueText}
                            onChange={handleOtherIssueChange}
                            placeholder="Please provide details about your issue..."
                            rows="4"
                            className="other-issue-textarea"
                          ></textarea>
                        </div>
                      )}
                    </div>
                  ) : (
                    // Add information to existing request
                    <div className="form-group">
                      <label htmlFor="additionalInfo">Add more information:</label>
                      <textarea
                        id="additionalInfo"
                        value={otherIssueText}
                        onChange={handleOtherIssueChange}
                        placeholder="Please provide any additional information or updates about your issue..."
                        rows="4"
                        className="other-issue-textarea"
                      ></textarea>
                    </div>
                  )}

                  {supportError && (
                    <div className="error-message">
                      {supportError}
                    </div>
                  )}

                  <div className="support-actions">
                    <button
                      className="cancel-btn"
                      onClick={closeSupportModal}
                      disabled={isSubmittingSupport}
                    >
                      Cancel
                    </button>
                    <button
                      className="submit-btn"
                      onClick={submitSupportRequest}
                      disabled={isSubmittingSupport}
                    >
                      {isSubmittingSupport ? (
                        <>
                          <span className="spinner"></span>
                          Submitting...
                        </>
                      ) : (
                        hasSupportRequest(activeSupportOrderId) ? 'Send Message' : 'Submit'
                      )}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default OrdersPage;